import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const updateJobDescription = createAsyncThunk("updateJobDescription", async ({ job_id, payload }, { rejectWithValue }) => {
	try {
		// Using POST per module convention
		const response = await axiosHttp.patch(`/jdoc/updatejdesc?job_id=${job_id}`, payload);
		return response?.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Something went wrong");
	}
});

const JobDescriptionUpdateSlice = createSlice({
	name: "JobDescriptionUpdateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		successMessage: null,
	},
	reducers: {
		resetJobDescriptionUpdate: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.successMessage = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateJobDescription.pending, (state) => {
			state.isLoading = true;
			state.error = null;
			state.successMessage = null;
		});
		builder.addCase(updateJobDescription.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			state.successMessage = action?.payload?.message || "Updated successfully";
		});
		builder.addCase(updateJobDescription.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.successMessage = null;
		});
	},
});

export const { resetJobDescriptionUpdate } = JobDescriptionUpdateSlice.actions;
export default JobDescriptionUpdateSlice.reducer;
